import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WizardComponent} from "./wizard.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {SharedModule} from "../shared/shared.module";
import {ModuleService} from "../shared/module.service";
import {RouterModule} from "@angular/router";
import {LocalStorageService} from "../shared/local-storage.service";
import {NgxErrorsModule} from "@ultimate/ngxerrors";
import {PopoverModule} from "ng2-popover";
import {OfferService} from "../shared/offer.service";
import {LoadingModule} from "ngx-loading";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule.forRoot(),
        SharedModule,
        RouterModule,
        NgxErrorsModule,
        PopoverModule,
        LoadingModule
    ],
    providers: [
        ModuleService,
        LocalStorageService,
        OfferService
    ],
    declarations: [WizardComponent]
})

export class WizardModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: WizardModule,
            providers: [],
        }
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/wizard/wizard.module.ts